import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../src/assets/github-mark.webp'
import _imports_1 from '../src/assets/github-mark-white.webp'
import _imports_2 from '../src/assets/sun.webp'
import _imports_3 from '../src/assets/moon.webp'


const _withScopeId = n => (_pushScopeId("data-v-f4387e8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "min-h-screen w-full bg-gradient-to-b from-stone-100 to-stone-300 dark:from-stone-950 dark:to-stone-800 font-share-tech" }
const _hoisted_2 = { class: "fixed top-0 left-0 right-0 z-50 h-16 bg-white dark:bg-stone-950 border-b-2 border-stone-600 dark:border-amber-500" }
const _hoisted_3 = { class: "flex items-center gap-2 h-full px-4" }
const _hoisted_4 = { class: "sr-only" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-6 h-6",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "clip-rule": "evenodd",
    "fill-rule": "evenodd",
    d: "M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
  })
], -1))
const _hoisted_6 = { class: "flex items-center shrink-0" }
const _hoisted_7 = {
  href: "https://github.com/xfdxfdxfd",
  target: "_blank",
  class: "flex items-center"
}
const _hoisted_8 = {
  key: 0,
  class: "h-8",
  src: _imports_0,
  alt: "GitHub"
}
const _hoisted_9 = {
  key: 1,
  class: "h-8",
  src: _imports_1,
  alt: "GitHub"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-4 text-2xl translate-y-0.5 font-semibold uppercase text-stone-950 dark:text-white" }, "xfdxfdxfd", -1))
const _hoisted_11 = { class: "ml-auto flex items-center gap-2 shrink-0" }
const _hoisted_12 = ["title"]
const _hoisted_13 = ["alt"]
const _hoisted_14 = ["alt"]
const _hoisted_15 = { class: "h-full px-2 py-4" }
const _hoisted_16 = { class: "space-y-3 font-medium" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "nav-icon flex-shrink-0" }
const _hoisted_19 = { class: "nav-text ms-3 whitespace-nowrap overflow-hidden transition-all duration-300" }
const _hoisted_20 = { class: "pt-28 sm:pt-16 transition-all duration-300" }
const _hoisted_21 = { class: "fixed top-16 left-0 right-0 z-40 px-4 py-2 sm:hidden bg-white/90 dark:bg-stone-950/90 backdrop-blur-sm border-b border-stone-300 dark:border-amber-500/30" }

import { ref, provide } from "vue";
import { useI18n } from "vue-i18n";
import { Icon } from "@iconify/vue";
import GlobalSearch from "@/components/GlobalSearch.vue";
import ChatWidget from "@/components/ChatWidget.vue";
import type { AppLocale } from "@/i18n";

type Theme = "light" | "dark";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { locale, t } = useI18n();

const theme = ref<Theme>("light");
const currentTab = ref("Intro");
const sidebarOpen = ref(false);
const navItems = ["Home", "Profile", "Project", "Resume", "Blog"];

provide("theme", () => theme.value);

const toggleLocale = (): void => {
  const next: AppLocale = locale.value === "en" ? "zh-TW" : "en";
  locale.value = next;
  localStorage.setItem("locale", next);
};

const toggleTheme = (): void => {
  if (document.documentElement.classList.contains("dark")) {
    document.documentElement.classList.remove("dark");
    localStorage.theme = "light";
    theme.value = "light";
  } else {
    document.documentElement.classList.add("dark");
    localStorage.theme = "dark";
    theme.value = "dark";
  }
};

// Theme initialization
if (localStorage.theme === "light") {
  document.documentElement.classList.remove("dark");
  theme.value = "light";
} else {
  document.documentElement.classList.add("dark");
  theme.value = "dark";
  localStorage.theme = "dark";
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.$route.path !== '/Home')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (sidebarOpen.value = !sidebarOpen.value)),
              type: "button",
              class: "inline-flex items-center p-2 text-sm text-stone-500 sm:hidden hover:bg-stone-300 dark:hover:bg-stone-700 focus:outline-none focus:ring-2 focus:ring-stone-200 dark:focus:ring-stone-800 shrink-0",
              "aria-controls": "default-sidebar"
            }, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)("common.openSidebar")), 1),
              _hoisted_5
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("a", _hoisted_7, [
            (theme.value === 'light')
              ? (_openBlock(), _createElementBlock("img", _hoisted_8))
              : (_openBlock(), _createElementBlock("img", _hoisted_9)),
            _hoisted_10
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(GlobalSearch, { class: "hidden sm:block" }),
          _createElementVNode("button", {
            onClick: toggleLocale,
            class: "h-9 min-w-[2.25rem] px-2 shrink-0 text-sm font-bold rounded-lg border border-stone-300 dark:border-amber-500/40 bg-white/80 dark:bg-stone-900/80 text-stone-700 dark:text-amber-200 hover:bg-stone-100 dark:hover:bg-stone-800 transition-colors",
            title: _unref(locale) === 'en' ? _unref(t)('common.switchToZh') : _unref(t)('common.switchToEn')
          }, _toDisplayString(_unref(locale) === "en" ? _unref(t)("common.switchToZh") : _unref(t)("common.switchToEn")), 9, _hoisted_12),
          _createElementVNode("button", {
            onClick: toggleTheme,
            class: "p-2 shrink-0"
          }, [
            (theme.value === 'light')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "h-8",
                  src: _imports_2,
                  alt: _unref(t)('common.lightMode')
                }, null, 8, _hoisted_13))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  class: "h-8",
                  src: _imports_3,
                  alt: _unref(t)('common.darkMode')
                }, null, 8, _hoisted_14))
          ])
        ])
      ])
    ]),
    (_ctx.$route.path !== '/Home')
      ? (_openBlock(), _createElementBlock("aside", {
          key: 0,
          id: "default-sidebar",
          class: _normalizeClass([
        'sidebar-3d fixed top-16 left-0 z-40 h-full transition-all duration-300 overflow-y-auto bg-transparent',
        sidebarOpen.value ? 'translate-x-0 w-64' : '-translate-x-full w-64',
        'sm:translate-x-0 sm:w-64',
      ]),
          "aria-label": "Sidebar"
        }, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("ul", _hoisted_16, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (name, index) => {
                return _createElementVNode("li", {
                  key: name,
                  onClick: ($event: any) => {
              currentTab.value = name;
              sidebarOpen.value = false;
            },
                  role: "button",
                  class: "nav-item-3d",
                  style: _normalizeStyle({ '--item-index': index })
                }, [
                  _createVNode(_component_RouterLink, {
                    to: '/' + name
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: _normalizeClass(`flex items-center text-xl p-2 ${
                  _ctx.$route.path === '/' + name
                    ? 'text-stone-900 dark:text-white bg-amber-300/90 dark:bg-amber-500/70 hover:bg-amber-500/90 dark:hover:bg-amber-700/70 border-amber-300/90 dark:border-amber-800/70'
                    : 'text-stone-900 dark:text-white bg-white/90 dark:bg-stone-950/70 hover:bg-stone-100/90 dark:hover:bg-stone-800/70 border-stone-300/90 dark:border-amber-500/70'
                } shadow-lg border   transition-all duration-200 backdrop-blur-sm w-16 h-16 hover:w-64`)
                      }, [
                        _createElementVNode("span", _hoisted_18, [
                          (name === 'Home')
                            ? (_openBlock(), _createBlock(_unref(Icon), {
                                key: 0,
                                icon: "mdi-light:home",
                                class: "w-12 h-12"
                              }))
                            : (name === 'Profile')
                              ? (_openBlock(), _createBlock(_unref(Icon), {
                                  key: 1,
                                  icon: "mdi-light:account",
                                  class: "w-12 h-12"
                                }))
                              : (name === 'Project')
                                ? (_openBlock(), _createBlock(_unref(Icon), {
                                    key: 2,
                                    icon: "mdi-light:folder-multiple",
                                    class: "w-12 h-12"
                                  }))
                                : (name === 'Resume')
                                  ? (_openBlock(), _createBlock(_unref(Icon), {
                                      key: 3,
                                      icon: "mdi-light:file",
                                      class: "w-12 h-12"
                                    }))
                                  : (name === 'Blog')
                                    ? (_openBlock(), _createBlock(_unref(Icon), {
                                        key: 4,
                                        icon: "mdi-light:comment-text",
                                        class: "w-12 h-12"
                                      }))
                                    : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)(`nav.${name}`)), 1)
                      ], 2)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ], 12, _hoisted_17)
              }), 64))
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    (sidebarOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (sidebarOpen.value = false)),
          class: "fixed top-16 left-0 right-0 bottom-0 z-30 bg-black/70 backdrop-blur-sm sm:hidden"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("main", _hoisted_20, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, {
            name: "page",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(GlobalSearch)
    ]),
    _createVNode(ChatWidget)
  ]))
}
}

})